import React, { useCallback, useEffect, useState } from 'react';
import { api, brl, dateStr } from '../lib/api';
import { toast } from 'sonner';
import { Plus, Minus, X } from 'lucide-react';

export default function Stock() {
  const [products, setProducts] = useState([]);
  const [moves, setMoves] = useState([]);
  const [modal, setModal] = useState(null); // {product, op_type}
  const [qty, setQty] = useState('');
  const [reason, setReason] = useState('');

  const load = useCallback(async () => {
    const [p, m] = await Promise.all([api.get('/products'), api.get('/stock/movements')]);
    setProducts(p.data); setMoves(m.data);
  }, []);
  useEffect(() => { load(); }, [load]);

  const open = (product, op_type) => { setModal({ product, op_type }); setQty(''); setReason(op_type === 'entry' ? 'Entrada de estoque' : 'Ajuste'); };

  const submit = async () => {
    const n = Number(qty);
    if (!n || n <= 0) { toast.error('Quantidade inválida'); return; }
    const delta = modal.op_type === 'entry' ? n : (modal.op_type === 'adjust_up' ? n : -n);
    try {
      await api.post('/stock/movement', { product_id: modal.product.id, quantity: delta, reason, op_type: modal.op_type });
      toast.success('Movimentação registrada');
      setModal(null); load();
    } catch (e) { toast.error(e?.response?.data?.detail || 'Erro'); }
  };

  const pmap = Object.fromEntries(products.map((p) => [p.id, p]));

  return (
    <div className="p-4 h-full overflow-y-auto space-y-4">
      <h2 className="text-xl font-black">Estoque</h2>
      <div className="space-y-2">
        {products.map((p) => (
          <div key={p.id} className="bg-white rounded-2xl border border-slate-200 p-3 flex items-center gap-3" data-testid={`stock-row-${p.id}`}>
            <div className="flex-1 min-w-0">
              <div className="font-bold truncate">{p.name}</div>
              <div className="text-xs text-slate-500">
                <span className={p.stock <= 0 ? 'text-red-600 font-bold' : p.stock <= (p.min_stock||0) ? 'text-amber-600 font-bold' : ''}>
                  Estoque: {p.stock} {p.stock <= 0 && '· Inativo automático'}
                </span>
              </div>
            </div>
            <button onClick={() => open(p, 'entry')} data-testid={`stock-entry-${p.id}`} className="h-9 px-3 rounded-lg bg-green-500 text-white font-bold text-sm flex items-center gap-1 active:scale-95"><Plus size={14}/> Entrada</button>
            <button onClick={() => open(p, 'adjust_down')} data-testid={`stock-adjust-${p.id}`} className="h-9 px-3 rounded-lg bg-slate-100 font-bold text-sm active:scale-95">Ajustar</button>
          </div>
        ))}
      </div>

      <div>
        <h3 className="font-bold mb-2 mt-6">Movimentações recentes</h3>
        <div className="space-y-1 text-sm">
          {moves.slice(0, 30).map((m) => (
            <div key={m.id} className="bg-white rounded-lg border border-slate-100 p-2 flex justify-between">
              <div>
                <div className="font-semibold">{pmap[m.product_id]?.name || 'Produto'}</div>
                <div className="text-xs text-slate-500">{dateStr(m.timestamp)} · {m.username} · {m.reason}</div>
              </div>
              <div className={`font-black ${m.quantity > 0 ? 'text-green-600' : 'text-red-600'}`}>{m.quantity > 0 ? '+' : ''}{m.quantity}</div>
            </div>
          ))}
        </div>
      </div>

      {modal && (
        <div className="fixed inset-0 z-50 bg-black/40 flex items-end sm:items-center sm:justify-center" onClick={() => setModal(null)}>
          <div onClick={(e) => e.stopPropagation()} className="bg-white w-full sm:max-w-md rounded-t-3xl sm:rounded-3xl p-4 space-y-3">
            <div className="flex items-center justify-between">
              <div className="font-black">{modal.op_type === 'entry' ? 'Entrada de estoque' : 'Ajuste de estoque'}</div>
              <button onClick={() => setModal(null)}><X/></button>
            </div>
            <div className="text-sm">{modal.product.name} · Atual: {modal.product.stock}</div>
            {modal.op_type !== 'entry' && (
              <div className="flex gap-2">
                <button onClick={() => setModal({...modal, op_type: 'adjust_up'})} className={`flex-1 h-10 rounded-lg font-bold ${modal.op_type === 'adjust_up' ? 'bg-green-500 text-white' : 'bg-slate-100'}`}>+ Adicionar</button>
                <button onClick={() => setModal({...modal, op_type: 'adjust_down'})} className={`flex-1 h-10 rounded-lg font-bold ${modal.op_type === 'adjust_down' ? 'bg-red-500 text-white' : 'bg-slate-100'}`}>− Reduzir</button>
              </div>
            )}
            <input type="number" placeholder="Quantidade" value={qty} onChange={(e) => setQty(e.target.value)} data-testid="stock-qty"
                   className="w-full h-12 rounded-xl border border-slate-200 px-3 text-lg font-bold"/>
            <input placeholder="Motivo" value={reason} onChange={(e) => setReason(e.target.value)} data-testid="stock-reason"
                   className="w-full h-11 rounded-xl border border-slate-200 px-3"/>
            <button onClick={submit} data-testid="stock-submit" className="w-full h-12 rounded-xl bg-orange-500 text-white font-black active:scale-[0.98]">Registrar</button>
          </div>
        </div>
      )}
    </div>
  );
}
